<template>
<div class="aggregationPointManagement">
  <div class="content">
    <el-form ref="form" :inline="true">
      <el-form-item>
        <el-button type="primary" @click="addEms()">添加EMS</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button v-if="isBatchDeleteBtn" type="danger" size="small" @click="batchDelete()">批量删除</el-button>
      </el-form-item>
    </el-form>
    <div class="leftTree">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <el-tree class="filter-tree" :data="treeData" :props="defaultProps" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span v-if="node.label.length<20">{{ node.label }}</span>
          <el-tooltip v-else effect="light" :content="node.label" :open-delay="500" placement="top">
            <span>{{ node.label }}</span>
          </el-tooltip>
          <span>
            <el-tooltip content="新增" :open-delay="500" placement="top" effect="light">
              <img src="../../../../static/images/boss/append.png" alt="" @click="() => append()" style="width: 12px;">
            </el-tooltip>
            <el-tooltip content="删除" :open-delay="500" placement="top" effect="light">
              <span @click="() => remove()">
                <img v-if="data.type == 2" src="../../../../static/images/boss/delete.png" alt="" style="width: 12px;">
              </span>
            </el-tooltip>
            <el-tooltip content="编辑" :open-delay="500" placement="top" effect="light">
              <img v-if="data.type == 2" src="../../../../static/images/boss/edit.png" alt="" @click="() => edit(data)" style="width: 12px;">
            </el-tooltip>
            <el-tooltip content="添加数据点" :open-delay="500" placement="top" effect="light">
              <img v-if="data.type == 2" src="../../../../static/images/boss/addDataPoint.png" alt="" @click="() => addDataPoint()" style="width: 12px;">
            </el-tooltip>
          </span>
        </span>
      </el-tree>
    </div>
    <div class="rightTable">
      <el-table ref="dataPointTable" :data="tableData" border highlight-current-row height="54vh" @selection-change="handleSelectionChange" style="width: 100%;">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="content" label="名称" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.content"></span>
          </template>
        </el-table-column>
        <el-table-column prop="fields" label="标识" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.fields"></span>
          </template>
        </el-table-column>
        <el-table-column prop="fieldsId" label="编号" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.fieldsId"></span>
          </template>
        </el-table-column>
        <el-table-column prop="dataType" label="数据类型">
          <template slot-scope="{ row }">
            <span v-html="row.dataType"></span>
          </template>
        </el-table-column>
        <el-table-column prop="dataTypeId" label="点类型">
          <template slot-scope="{ row }">
            <span v-html="row.dataTypeId"></span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="defaultValue" label="默认值" width="80" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.defaultValue"></span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="coefficient" label="系数" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.coefficient"></span>
          </template>
        </el-table-column> -->
        <el-table-column prop="authorization" label="权限" width="60">
          <template slot-scope="{ row }">
            {{ row.authorization == 0 ? "只读" : row.authorization == 1 ? "只写" : "读写" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="165">
          <template slot-scope="{ row }">
            <span v-html="row.createTime"></span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="修改时间" width="165">
          <template slot-scope="{ row }">
            <span v-html="row.updateTime"></span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="fieldDescribe" label="描述" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.fieldDescribe"></span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="range" label="数值范围" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.range"></span>
          </template>
        </el-table-column> -->
        <el-table-column prop="unit" label="单位" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-html="row.unit"></span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="{ row }">
            <el-button class="btn" type="text" size="small" @click="onEdit(row)">修改</el-button>
            <el-button class="btn" type="text" size="small" @click="onDelete(row)">删除</el-button>
            <el-button class="btn" type="text" size="small" @click="computationalLogic(row)">计算逻辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <!-- EMS配置 -->
  <Dialog ref="emsConfigDialog" title="EMS配置">
    <el-form ref="emsConfigForm" :rules="emsConfigRules" :model="emsConfigForm" label-width="100px">
      <el-form-item label="EMS名称:" prop="emsName">
        <el-input v-model="emsConfigForm.emsName" placeholder="EMS名称" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="SN号:" prop="sn">
        <el-input v-model="emsConfigForm.sn" placeholder="SN号" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addProjectEms('emsConfigForm')" style="margin-left: 36%;transform: translateX(-50%);">保存</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
  <!-- 设备配置 -->
  <Dialog ref="deviceConfigDialog" title="设备配置">
    <el-form ref="deviceConfigForm" :rules="deviceConfigRules" :model="deviceConfigForm" label-width="130px">
      <el-form-item label="设备标识:" prop="code" required>
        <el-input v-model="deviceConfigForm.code" placeholder="设备标识" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="设备名称:" prop="content" required>
        <el-input v-model="deviceConfigForm.content" placeholder="设备名称" style="width: 80%;"></el-input>
      </el-form-item>
      <!-- <el-form-item label="完整设备前缀编号:">
        <el-input v-model="deviceConfigForm.fullPrefixCode" placeholder="完整设备前缀编号" style="width: 80%;"></el-input>
      </el-form-item> -->
      <el-form-item label="类型:" prop="topType" required>
        <el-select v-model="deviceConfigForm.topType" clearable placeholder="类型" style="width: 60%;" @change="searchProductList(deviceConfigForm.topType)">
          <el-option v-for="(item, index) in levelTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="deviceTypeList.length>0" label="设备类型:" prop="type">
        <el-select v-model="deviceConfigForm.type" clearable placeholder="设备类型" @change="pickChange" style="width: 60%;">
          <el-option v-for="(item, index) in deviceTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="厂商:" prop="manufacturersId">
        <el-select v-model="deviceConfigForm.manufacturersId" clearable placeholder="厂商" style="width: 60%;">
          <el-option v-for="(item, index) in manufacturersList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="设备类型:">
        <el-select v-model="deviceConfigForm.type" clearable placeholder="设备类型" style="width: 60%;">
          <el-option v-for="(item, index) in deviceTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="saveProjectEquipmentInfo('deviceConfigForm')" style="margin-left: 36%;transform: translateX(-50%);">保存</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
  <!-- 数据点配置 -->
  <Dialog ref="dataPointConfigDialog" title="数据点配置">
    <el-form ref="dataPointConfigForm" :rules="dataPointConfigRules" :model="dataPointConfigForm" label-width="120px">
      <el-form-item label="数据点名称:" prop="content" required>
        <el-input v-model="dataPointConfigForm.content" placeholder="请输入数据点名称" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="数据点标识:" prop="fields" required>
        <el-input v-model="dataPointConfigForm.fields" placeholder="请输入数据点标识" style="width: 80%;"></el-input>
      </el-form-item>
      <!-- <el-form-item label="数据点编号:" prop="fieldsId">
        <el-input v-model="dataPointConfigForm.fieldsId" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <el-form-item label="数据类别:" prop="dataType">
        <el-select v-model="dataPointConfigForm.dataType" clearable placeholder="数据类别">
          <el-option v-for="(item, index) in dataTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据点类型:" prop="dataTypeId">
        <el-select v-model="dataPointConfigForm.dataTypeId" clearable filterable placeholder="数据点类型">
          <el-option v-for="(item, index) in dataTypeIdList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="数据类型:" prop="type">
        <el-select v-model="dataPointConfigForm.type" clearable placeholder="数据类型">
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="数值类型:" prop="valueType">
        <el-select v-model="dataPointConfigForm.valueType" clearable placeholder="数值类型">
          <el-option v-for="(item, index) in valueTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="默认值:" prop="defaultValue">
        <el-input v-model="dataPointConfigForm.defaultValue" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="点描述:" prop="fieldDescribe">
        <el-input v-model="dataPointConfigForm.fieldDescribe" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="系数:" prop="coefficient">
        <el-input v-model="dataPointConfigForm.coefficient" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <el-form-item label="权限:" prop="authorization">
        <el-select v-model="dataPointConfigForm.authorization" clearable placeholder="权限">
          <el-option v-for="(item, index) in authorityList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="数值范围:" prop="range">
        <el-input v-model="dataPointConfigForm.range" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item> -->
      <el-form-item label="数据点单位:" prop="unit">
        <el-input v-model="dataPointConfigForm.unit" placeholder="请输入" style="width: 80%;"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="confirmDataPointConfigData('dataPointConfigForm')" style="margin-top: 20px;margin-left: 50%;transform: translateX(-50%);">确定</el-button>
  </Dialog>
  <!-- 计算逻辑 -->
  <Dialog ref="computationalLogicDialog" title="计算逻辑" dlgWidth="50%">
    <div @click="getMouseXY($event)">
      <el-form ref="computationalLogicForm" label-width="120px">
        <el-form-item label="聚合计算方式:" prop="calculationMethod">
          <el-select v-model="calculationMethod" clearable placeholder="聚合计算方式">
            <el-option v-for="(item, index) in methodList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="padding: 0px 20px;">
        <el-button @click="handleAddTable()" type="primary" size="mini" icon="el-icon-plus" circle style="margin-bottom: 10px;"></el-button>
        <el-table ref="computationalLogicTable" :row-class-name="logicTableRowClassName" :data="computationalLogicTableData" border highlight-current-row height="30vh" @row-click="clickRow" style="width: 100%;">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="fields" label="数据点标识" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sn" label="EMS编号"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="{ row }">
              <el-button class="btn" type="text" size="small" @click="onLogicChoose(row)">选择</el-button>
              <!-- <div v-if="row.isChooseBlock" class="chooseBlock">
                <el-select class="searchKeyClass" v-model="measuringPoint" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" :loading="loading" style="width: 200px;">
                  <el-option v-html="item.label" v-for="item in formOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                  <el-button :disabled="formOptions.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                </el-select>
                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="onsubmit()">确定</el-button>
              </div> -->
              <el-dialog width="30%" title="选择测点" :visible.sync="row.isChooseBlock" append-to-body>
                <el-select class="searchKeyClass" v-model="measuringPoint" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" :loading="loading" style="width: 200px;">
                  <el-option v-html="item.name" v-for="item in formOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                  <!-- <el-button :disabled="formOptions.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button> -->
                </el-select>
                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="onsubmit()">确定</el-button>
              </el-dialog>
              <el-button class="btn" type="text" size="small" @click="onLogicDelete(row)">删除</el-button>
              <el-button v-if="calculationMethod==3" class="btn" type="text" size="small" @click="onRuleConfig(row)">规则</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span>
        <el-button type="primary" @click="saveComputationalLogicData()" style="margin-top: 20px;margin-left: 36.5%;">保 存</el-button>
        <el-button type="success" @click="generateComputationalLogicData()" style="margin-top: 20px;margin-left: 10%;">生 成</el-button>
      </span>
    </div>
  </Dialog>
  <!-- 配置规则 -->
  <Dialog ref="ruleConfigDialog" title="配置规则" dlgWidth="20%">
    <div style="margin-bottom: 20px;padding-left: 10px;">
      <span style="margin-right: 5px;">默认值:</span>
      <span>
        <el-input v-model="defaultVal" placeholder="请输入" style="width: 79%;"></el-input>
      </span>
    </div>
    <div style="padding: 0px 20px;">
      <el-button @click="handleRuleAddTable()" type="primary" size="mini" icon="el-icon-plus" circle style="margin-bottom: 10px;"></el-button>
      <el-table ref="ruleConfigTable" :row-class-name="ruleTableRowClassName" :data="ruleTableData" border highlight-current-row height="30vh" @row-click="rowClick" style="width: 100%;">
        <el-table-column prop="sourceVal" label="源值">
          <template slot-scope="{ row }">
            <el-input v-model="row.sourceVal"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="targetVal" label="目标值">
          <template slot-scope="{ row }">
            <el-input v-model="row.targetVal"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span style="display: block;margin-top: 20px;text-align: center;">
      <el-button type="primary" @click="saveRule()" size="small">确定</el-button>
    </span>
  </Dialog>
</div>
</template>

<script>
import Dialog from '@/components/dialog';
import PROJECTAPI from '@/api/project';
import VENDORAPI from '@/api/vendorManagement';
import EquipmentLibraryApi from '@/api/equipmentLibrary';
import D_PROJECTAPI from '@/views/design/api/project';
import API from '@/api/glconfig';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      emsConfigForm: {
        emsName: '',
        projectId: '',
        sn: '',
      },
      emsConfigRules: {
        emsName: [{
          required: true,
          message: '请输入EMS名称',
          trigger: 'blur'
        }],
        sn: [{
          required: true,
          message: '请输入sn号',
          trigger: 'blur'
        }]
      },
      levelTypeList: [],
      productTypeList: [],
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'childList',
        label(data) {
          return data.type == 1 ? data.emsSn + " (" + data.emsName + ")" : data.equipCode + " (" + data.equipName + ")"
        }
      },
      tableData: [],
      deviceConfigForm: {
        content: '',
        code: '',
        topType: '',
        type: '',
        manufacturersId: '',
        // isExistsBattery: true,
        // isRepairZero: true
      },
      deviceConfigRules: {
        content: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入设备标识',
          trigger: 'blur'
        }],
        topType: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }]
      },
      manufacturersList: [],
      deviceTypeList: [],
      dataPointConfigForm: {
        content: '',
        fields: '',
        // type: '',
        valueType: '',
        fieldCode: '',
        // defaultValue: '',
        // fieldDescribe: '',
        // coefficient: '',
        authorization: '',
        unit: ''
      },
      dataPointConfigRules: {
        content: [{
          required: true,
          message: '请输入数据点名称',
          trigger: 'blur'
        }],
        fields: [{
          required: true,
          message: '请输入数据点标识',
          trigger: 'blur'
        }],
        dataType: [{
          required: true,
          message: '请选择数据类别',
          trigger: 'change'
        }],
        valueType: [{
          required: true,
          message: '请选择数值类型',
          trigger: 'change'
        }],
        authorization: [{
          required: true,
          message: '请选择权限',
          trigger: 'change'
        }],
        unit: [{
          required: true,
          message: '请输入权限',
          trigger: 'blur'
        }],
      },
      dataTypeList: [{
        id: 0,
        name: '未知'
      }, {
        id: 1,
        name: '遥测'
      }, {
        id: 2,
        name: '遥信'
      }, {
        id: 3,
        name: '遥调'
      }, {
        id: 4,
        name: '遥控'
      }],
      typeList: [{
        id: 1,
        name: '模拟量'
      }, {
        id: 2,
        name: '数字量'
      }, {
        id: 3,
        name: '信号量'
      }],
      valueTypeList: [{
        id: 1,
        name: 'int'
      }, {
        id: 2,
        name: 'float'
      }, {
        id: 3,
        name: 'string'
      }],
      dataTypeIdList: [],
      authorityList: [{
        id: 0,
        name: '只读'
      }, {
        id: 1,
        name: '只写'
      }, {
        id: 2,
        name: '读写'
      }],
      currTreeData: {},
      isTableEdit: false,
      isTreeEdit: false,
      filterType: '0',
      currFieldId: '',
      selectRows: [],
      isBatchDeleteBtn: false,
      bindDeviceLibraryIds: [],
      calculationMethod: 1,
      methodList: [{
        id: 1,
        name: '相加'
      }, {
        id: 2,
        name: '相减'
      }, {
        id: 3,
        name: '自定义'
      }, {
        id: 4,
        name: '相乘'
      }, {
        id: 5,
        name: '累加'
      }, {
        id: 6,
        name: '每日'
      }],
      computationalLogicTableData: [],
      measuringPoint: '',
      formOptions: [],
      currData: {},
      index: 0,
      equipRow: {},
      ruleTableData: [],
      ruleIndex: 0,
      defaultVal: '',
      computeLogicArr: [],
      loading: false,
      start: 0,
      end: 10,
      pageTotal: 10,
      keyWord: ''
    };
  },
  components: {
    Dialog
  },
  created() {
    this.searchDataFieldTypes();
    this.onSearch();
    this.searchManufacturerList();
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    selectRows(val) {
      if (val.length > 0) {
        this.isBatchDeleteBtn = true;
      } else {
        this.isBatchDeleteBtn = false;
      }
    }
  },
  methods: {
    //新增EMS
    addEms() {
      this.emsConfigForm = {};
      this.$refs.emsConfigDialog.open();
    },
    //添加项目EMS
    addProjectEms(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.emsConfigForm;
          params.projectId = this.projectId;
          PROJECTAPI.addProjectEmsV2(params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("添加成功！");
              this.$refs.emsConfigDialog.close();
              this.onSearch();
            }
          });
        }
      })
    },
    //产品类型列表
    searchProductList(data) {
      if (!this.isTreeEdit) {
        this.deviceConfigForm.type = "";
      }
      if (data != 3) {
        this.productTypeList = [];
      } else {
        if (this.isTreeEdit) {
          this.deviceConfigForm.type = "";
        }
      }
      let params = {
        parentId: data
      };
      EquipmentLibraryApi.searchProductList(params).then(res => {
        if (res.data.code == 200) {
          if (data == 0) {
            this.levelTypeList = res.data.data;
          } else if (data == 3) {
            this.productTypeList = res.data.data;
          }
          this.deviceTypeList = res.data.data;
        }
      });
    },
    //层级类型列表
    searchDataFieldTypes() {
      EquipmentLibraryApi.searchDataFieldTypes().then(res => {
        if (res.data.code == 200) {
          this.dataTypeIdList = res.data.data;
        }
      });
    },
    onSearch() {
      let params = {
        projectId: this.projectId
      }
      PROJECTAPI.getProjectEquipmentTreeWithVirtual(params).then(res => {
        if (res.data.code == 200 && !res.data.errors) {
          this.treeData = res.data.data;
        }
        if (res.data.errors) {
          this.$message.error(res.data.errors);
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.type == 1 ? data.emsSn.indexOf(value) !== -1 || data.emsName.indexOf(value) !== -1 : data.equipCode.indexOf(value) !== -1 || data.equipName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.currTreeData = data;
      if (data.equipId != "") {
        let params = {
          deviceId: data.equipId
        }
        PROJECTAPI.searchProjectEquipFields(params).then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data;
            for (let i in this.tableData) {
              for (let j in this.dataTypeIdList) {
                if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                  this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
                }
              }
              for (let j in this.dataTypeList) {
                if (this.tableData[i].dataType == this.dataTypeList[j].id) {
                  this.tableData[i].dataType = this.dataTypeList[j].name;
                }
              }
            }
          }
        });
      }
    },
    searchProjectEquipFields(data) {
      let params = {
        deviceId: data.equipId
      }
      PROJECTAPI.searchProjectEquipFields(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
          for (let i in this.tableData) {
            if (this.tableData[i].id == this.currFieldId) {
              this.$refs.dataPointTable.setCurrentRow(this.tableData[i]);
            }
            for (let j in this.dataTypeIdList) {
              if (this.tableData[i].dataTypeId == this.dataTypeIdList[j].id) {
                this.tableData[i].dataTypeId = this.dataTypeIdList[j].name;
              }
            }
            for (let j in this.dataTypeList) {
              if (this.tableData[i].dataType == this.dataTypeList[j].id) {
                this.tableData[i].dataType = this.dataTypeList[j].name;
              }
            }
          }
        }
      });
    },
    append() {
      this.searchProductList(0);
      this.isTreeEdit = false;
      this.deviceConfigForm = {};
      this.$refs.deviceConfigDialog.open();
    },
    pickChange() {
      this.$forceUpdate();
    },
    searchManufacturerList() {
      VENDORAPI.searchManufacturerList().then(res => {
        if (res.data.code == 200) {
          this.manufacturersList = res.data.data;
        }
      });
    },
    edit(data) {
      this.currTreeData = data;
      this.isTreeEdit = true;
      this.$refs.deviceConfigDialog.open();
      this.searchProductList(0);
      this.getProjectEquipmentInfo();
    },
    getProjectEquipmentInfo() {
      let params = {
        deviceId: this.currTreeData.equipId
      };
      PROJECTAPI.getProjectEquipmentInfo(params).then(res => {
        if (res.data.code == 200) {
          this.deviceConfigForm = res.data.data;
          this.deviceConfigForm.manufacturersId = res.data.data.manufacturersId == 0 ? "" : res.data.data.manufacturersId;
          this.searchProductList(this.deviceConfigForm.topType);
        }
      });
    },
    //添加/修改项目设备
    saveProjectEquipmentInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.deviceConfigForm.projectId = this.projectId;
          let params = this.deviceConfigForm;
          params.type == "" ? params.type = params.topType : params.type;
          if (!this.isTreeEdit) {
            params.parentId = this.currTreeData.equipId == "" ? 0 : this.currTreeData.equipId;
            params.emsId = this.currTreeData.emsId;
            PROJECTAPI.addProjectEquipmentInfoV2(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("添加成功！");
                this.$refs.deviceConfigDialog.close();
                this.onSearch();
              }
            });
          } else {
            PROJECTAPI.updateProjectEquipmentInfoV2(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("修改成功！");
                this.$refs.deviceConfigDialog.close();
                this.onSearch();
              }
            });
          }
        }
      })
    },
    remove() {
      let self = this;
      this.$confirm('选项中可能存在子选项，删除后将连带子选项一起删除， 确定要执行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.deleteProjectEquipmentInfo();
        })
        .catch(() => {});
    },
    deleteProjectEquipmentInfo() {
      let params = {
        deviceId: this.currTreeData.equipId
      };
      PROJECTAPI.deleteProjectEquipmentInfo(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.onSearch();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    onSelectionChange(val) {
      let bindDeviceLibraryIds = [];
      for (let i in val) {
        bindDeviceLibraryIds.push({
          deviceId: val[i].deviceId,
          deviceCode: val[i].deviceCode + "_" + new Date().getTime()
        });
      }
      this.bindDeviceLibraryIds = bindDeviceLibraryIds;
    },
    addDataPoint() {
      this.isTableEdit = false;
      this.dataPointConfigForm = {};
      this.$refs.dataPointConfigDialog.open();
    },
    confirmDataPointConfigData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {};
          if (!this.isTableEdit) { //添加数据点
            this.dataPointConfigForm.equipId = this.currTreeData.equipId;
            params = this.dataPointConfigForm;
            PROJECTAPI.addProjectEquipmentFieldsInfoV2(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("添加成功！");
                this.$refs.dataPointConfigDialog.close();
                this.searchProjectEquipFields(this.currTreeData);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
          } else { // 修改数据点
            params = {
              authorization: this.dataPointConfigForm.authorization,
              // coefficient: this.dataPointConfigForm.coefficient,
              content: this.dataPointConfigForm.content,
              dataType: this.dataPointConfigForm.dataType,
              dataTypeId: this.dataPointConfigForm.dataTypeId,
              // defaultValue: this.dataPointConfigForm.defaultValue,
              emsId: this.dataPointConfigForm.emsId,
              equipId: this.dataPointConfigForm.equipId,
              // fieldDescribe: this.dataPointConfigForm.fieldDescribe,
              fields: this.dataPointConfigForm.fields,
              fieldsId: this.dataPointConfigForm.fieldsId,
              projectId: this.dataPointConfigForm.projectId,
              // range: this.dataPointConfigForm.range,
              unit: this.dataPointConfigForm.unit
            };
            PROJECTAPI.updateProjectEquipmentFieldInfoV2(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("修改成功！");
                this.$refs.dataPointConfigDialog.close();
                this.searchProjectEquipFields(this.currTreeData);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
          }
        }
      })
    },
    onEdit(row) {
      this.getProjectEquipmentFieldInfo(row);
      this.isTableEdit = true;
      this.$refs.dataPointConfigDialog.open();
    },
    getProjectEquipmentFieldInfo(row) {
      let params = {
        fieldId: row.fieldsId
      }
      PROJECTAPI.getProjectEquipmentFieldInfo(params).then(res => {
        if (res.data.code == 200) {
          this.dataPointConfigForm = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.selectRows = val;
    },
    onDelete(row) {
      let self = this;
      this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let fieldIds = [];
          fieldIds.push(row.fieldsId);
          self.deleteProjectEquipmentFieldsInfo(fieldIds.toString());
        })
        .catch(() => {});
    },
    //批量删除
    batchDelete() {
      let self = this;
      this.$confirm('确定要删除这些吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let fieldIds = [];
          for (let i in self.selectRows) {
            fieldIds.push(self.selectRows[i].fieldsId);
          }
          self.deleteProjectEquipmentFieldsInfo(fieldIds);
        })
        .catch(() => {});
    },
    deleteProjectEquipmentFieldsInfo(id) {
      let params = {
        fieldIds: id
      };
      PROJECTAPI.deleteProjectEquipmentFieldsInfo(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.searchProjectEquipFields(this.currTreeData);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    computationalLogic(row) {
      this.equipRow = row;
      this.$refs.computationalLogicDialog.open();
      this.searchProjectEquipAggregationFieldsComputeLogicConfigWithVirtual(row.fieldsId);
    },
    searchProjectEquipAggregationFieldsComputeLogicConfigWithVirtual(id) {
      let params = {
        fieldsId: id
      };
      PROJECTAPI.searchProjectEquipAggregationFieldsComputeLogicConfigWithVirtual(params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data) {
            this.calculationMethod = res.data.data.computeType;
            this.computationalLogicTableData = res.data.data.fieldsList;
            let computeLogic = res.data.data.computeLogic;
            if (computeLogic != "") {
              this.computeLogicArr = computeLogic.split("|");
              this.computeLogicArr.forEach((item, index) => {
                this.computationalLogicTableData[index].computeLogic = item;
              })
            }
            this.logicId = res.data.data.id;
          } else {
            this.calculationMethod = 1;
            this.computationalLogicTableData = [];
            this.logicId = 0;
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    // 把每一行的索引放进row
    logicTableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },
    async clickRow(row) {
      //让点击的这行索引赋值给变量index
      this.index = row.index;
    },
    handleAddTable() {
      const newLine = {
        fields: "",
        sn: ""
      }
      this.computationalLogicTableData.push(newLine);
    },
    onRuleConfig(row) {
      this.$refs.ruleConfigDialog.open();
      let str = this.computeLogicArr[row.index];
      if (str != undefined) {
        let val = str.split(";")[0];
        let data = val.split(",");
        let row = [];
        for (let i = 0; i < data.length; i++) {
          let obj = {
            sourceVal: data[i].split("-")[0],
            targetVal: data[i].split("-")[1]
          };
          row.push(obj);
        }
        this.ruleTableData = row;
        this.defaultVal = str.split(";")[1];
      } else {
        this.defaultVal = "";
        this.ruleTableData = [];
      }
    },
    // 把每一行的索引放进row
    ruleTableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },
    async rowClick(row) {
      //让点击的这行索引赋值给变量index
      this.ruleIndex = row.index;
    },
    handleRuleAddTable() {
      const newLine = {
        sourceVal: "",
        targetVal: ""
      }
      this.ruleTableData.push(newLine);
    },
    saveRule() {
      let str = "";
      let arr = [];
      this.ruleTableData.forEach((item) => {
        arr.push(item.sourceVal + "-" + item.targetVal);
      })
      if (arr.length > 1) {
        str = arr.join(",");
      } else {
        str = arr[0];
      }
      str += ";" + this.defaultVal;
      this.computationalLogicTableData[this.index].computeLogic = str;
      this.$refs.ruleConfigDialog.close();
    },
    onLogicChoose(row) {
      this.measuringPoint = "";
      this.currData = row;
      this.$set(row, 'isChooseBlock', !row.isChooseBlock);
    },
    remoteMethod(query) {
      if (query != "") {
        this.keyWord = query;
        try {
          let params = {
            projectId: this.projectId,
            query: query,
            kind: 0
          };
          PROJECTAPI.fuzzySearchFieldsWithFieldsId(params).then(res => {
            if (res.data.code == 200) {
              this.$set(this.formOptions, 0, res.data.data);
              this.formOptions = res.data.data;
            }
          });
        } catch (e) {
          console.log(e)
        }
      }
    },
    /* remoteMethod(query) {
      this.keyWord = query;
      this.start = 0;
      this.end = 10;
      this.loading = true;
      if (query != '') {
        try {
          let params = {
            start: this.start,
            productTypeId: '',
            searchKey: query,
            end: this.end,
            topProductTypeId: '',
            type: 0,
            projectId: this.projectId
          };
          D_PROJECTAPI.getProjectFieldsByEs(params).then(res => {
            if (res.data.code == 200) {
              var result = res.data.data.dataList;
              if (result.length > 0) {
                for (let i in result) {
                  result[i].label = result[i].emsSn + '|' + result[i].fields + '|' + result[i].fieldContent;
                  var el = document.createElement('div');
                  el.innerHTML = result[i].label;
                  el.getElementsByTagName('a'); // Live NodeList of your anchor elements
                  result[i].value = el.innerText;
                  result[i].id = result[i].fieldsId;
                }
                this.formOptions = result;
              }
              this.pageTotal = res.data.data.totalCount != 0 ? res.data.data.totalCount : 10;
            }
          });
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      }
    }, */
    searchMore() {
      this.start += 10;
      this.end += 10;
      this.loading = true;
      let self = this;
      try {
        let params = {
          start: this.start,
          productTypeId: null,
          searchKey: this.keyWord,
          end: this.end,
          topProductTypeId: null,
          type: 0,
          projectId: this.projectId
        };
        D_PROJECTAPI.getProjectFieldsByEs(params).then(res => {
          if (res.data.code == 200) {
            var result = res.data.data.dataList;
            if (result.length > 0) {
              for (let i in result) {
                result[i].label = result[i].emsSn + '|' + result[i].fields + '|' + result[i].fieldContent;
                var ele = document.createElement('div');
                ele.innerHTML = result[i].label;
                ele.getElementsByTagName('a'); // Live NodeList of your anchor elements
                result[i].value = ele.innerText;
                result[i].id = result[i].fieldsId;
              }
              this.$nextTick(function () {
                self.formOptions = self.formOptions.concat(result);
                self.formOptions = self.deleteObject(self.formOptions);
              });
            } else {
              this.$message.warning('已无更多数据！');
            }
          }
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    //删除数组对象中的重复对象
    deleteObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return (Number(a) - Number(b));
        });
        var str = '';
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    onsubmit() {
      this.$set(this.currData, 'isChooseBlock', false);
      for (let i in this.formOptions) {
        if (this.measuringPoint == this.formOptions[i].id) {
          this.computationalLogicTableData[this.index].fieldsId = this.formOptions[i].id;
          //EMS编号
          this.computationalLogicTableData[this.index].sn = this.formOptions[i].value.split(";")[0];
          //数据点标识
          this.computationalLogicTableData[this.index].fields = this.formOptions[i].value.split(";")[1];
        }
      }
    },
    getMouseXY(e) {
      if (e.target.innerText != "选择") {
        this.$set(this.currData, 'isChooseBlock', false);
      }
    },
    onLogicDelete(row) {
      this.computationalLogicTableData.splice(row.index, 1);
    },
    saveComputationalLogicData() {
      if (this.computationalLogicTableData.length > 0) {
        let computParams = "";
        let computeLogic = "";
        let arr = [];
        let logicArr = [];
        this.computationalLogicTableData.forEach((item) => {
          if (item.fieldsId) {
            arr.push(item.fieldsId);
            logicArr.push(item.computeLogic);
          }
        })
        if (arr.length > 1) {
          var sarr = arr.sort();
          for (let i = 0; i < sarr.length; i++) {
            if (sarr[i] == sarr[i + 1]) {
              this.$message.warning("存在重复的数据点！");
              return false;
            }
          }
          computParams = arr.join(",");
        } else {
          computParams = arr[0];
        }
        if (logicArr.length > 1) {
          computeLogic = logicArr.join("|");
        } else {
          computeLogic = logicArr[0];
        }
        let params = {
          computeLogic: this.calculationMethod == 3 ? computeLogic : "", //相加或相减不用传
          computeParams: computParams, //数据点id，字符串间隔
          computeType: this.calculationMethod, //计算类型:1相加,2相减,3自定义,4相乘,5累加,6每日
          equipId: this.equipRow.equipId,
          fieldsInfoId: this.equipRow.fieldsId,
          hasTakeEffect: 0, //默认传0
          id: this.logicId == 0 ? 0 : this.logicId, //默认传0
          projectId: this.projectId
        };
        PROJECTAPI.saveProjectEquipAggregationFieldsComputeLogicConfig(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("保存成功！");
          }
        });
      } else {
        this.$message.warning("请先配置逻辑！");
      }
    },
    generateComputationalLogicData() {
      if (this.computationalLogicTableData.length > 0) {
        let params = {
          fieldsId: this.equipRow.fieldsId
        };
        PROJECTAPI.takeEffectProjectEquipAggregationFieldsComputeLogicConfig(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功！");
          }
        });
      } else {
        this.$message.warning("请先配置逻辑！");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.aggregationPointManagement {
  width: 100%;
  height: 100%;

  .leftTree {
    float: left;
    border-right: 1px solid;
    width: 350px;
    height: 56vh;
    padding-right: 20px;

    .filter-tree {
      height: 95%;
      margin-top: 10px;
      overflow: auto;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      overflow-x: auto;
      padding-right: 5px;

      &::-webkit-scrollbar {
        height: 5px;
      }
    }

    >>> .el-tree-node__content {
      height: 35px;
      line-height: 25px;
    }
  }

  .rightTable {
    float: left;
    width: calc(100% - 350px);
    padding: 10px 0px 10px 20px;
  }

  .btn {
    padding: 0px;
    font-size: 12px !important;
    margin-left: 10px;

    &span {
      font-size: 12px !important;
    }
  }

  button.el-button.btn.el-button--text.el-button--mini {
    margin-left: 5px !important;
  }

  >>> .el-input-group__prepend {
    width: 100px;
    background: linear-gradient(135deg, #3897C1 0%, #1D7197 100%);
    color: #fff;
    font-family: PingFang;
    font-weight: 600;
  }

  >>> .el-input-group__append {
    width: 40px;
    background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
    border-radius: 0px 4px 4px 0px;
    color: #fff;
  }

  >>> .el-input-group>.el-input__inner {
    border: 1px solid #E7E8EB;
    border: 1px 0px;
    border-radius: 0px !important;
  }

  .keywordClass {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .filterType {
    >>> .el-icon-arrow-up:before {
      color: #fff;
    }

    >>> .el-input__inner {
      background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
      border: 0px !important;
      border-radius: 4px 0px 0px 4px !important;
      box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
      color: #fff;
    }
  }

  .searchKeyClass {
    >>> .el-input__inner {
      border-radius: 0px 4px 4px 0px !important;
    }

    >>> .el-select .el-input__inner:focus,
    >>> .el-select .el-input.is-focus .el-input__inner {
      border-color: #f3f4f5;
    }
  }

  #sector {
    position: absolute;
  }

  #sector .moreIcon {
    margin-left: 5px;
  }

  #sector ul {
    width: 12px;
    position: absolute;
    z-index: 99;
  }

  #sector ul li {
    list-style: none;
    position: absolute;
    background: #ccc;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    left: -18px;
    top: -42px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-transform-origin: 100% 100%;
    -moz-transform-origin: 100% 100%;
    -ms-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }

  #sector .sector1 {
    margin-top: -25px;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector2 {
    margin-top: -15px;
    margin-left: 2px;
    // -webkit-transform: rotate(-30deg);
    // -moz-transform: rotate(-30deg);
    // -ms-transform: rotate(-30deg);
    // transform: rotate(-30deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector3 {
    margin-top: 0px;
    margin-left: -12px;
    // -webkit-transform: rotate(-60deg);
    // -moz-transform: rotate(-60deg);
    // -ms-transform: rotate(-60deg);
    // transform: rotate(-60deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector4 {
    margin-top: 20px;
    margin-left: -20px;
    // -webkit-transform: rotate(-90deg);
    // -moz-transform: rotate(-90deg);
    // -ms-transform: rotate(-90deg);
    // transform: rotate(-90deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector5 {
    margin-top: 40px;
    margin-left: -12px;
    // -webkit-transform: rotate(-120deg);
    // -moz-transform: rotate(-120deg);
    // -ms-transform: rotate(-120deg);
    // transform: rotate(-120deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector6 {
    margin-top: 56px;
    margin-left: 1px;
    // -webkit-transform: rotate(-150deg);
    // -moz-transform: rotate(-150deg);
    // -ms-transform: rotate(-150deg);
    // transform: rotate(-150deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector .sector7 {
    margin-top: 66px;
    margin-left: 20px;
    // -webkit-transform: rotate(270deg);
    // -moz-transform: rotate(270deg);
    // -ms-transform: rotate(270deg);
    // transform: rotate(270deg);

    img:hover {
      transform: scale(1.5);
    }
  }

  #sector ul li p {
    position: absolute;
    top: 73px;
    left: 120px;
  }

  .chooseBlock {
    background: rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    margin-left: 10%;
    margin-top: 5%;
    padding: 5px;
    position: absolute;
    z-index: 99;

    >>> .el-input--mini .el-input__inner {
      height: 33px;
      line-height: 33px;
    }
  }
}
</style>
<style lang="scss">
.el-select-dropdown.el-popper.filterTypePopper {
  background: #FFFFFF linear-gradient(135deg, #3897C1 0%, #1D7197 100%) !important;
  box-shadow: 0px 4px 17px 0px rgba(187, 187, 187, 0.5);
}

.filterTypePopper .el-select-dropdown__item {
  color: #fff;
}

.filterTypePopper .el-select-dropdown__item.selected {
  background: #fff;
  color: #2E81B1;
}

.filterTypePopper .el-select-dropdown__item.hover {
  background: #1D7197;
  color: #fff;
}

.filterTypePopper .popper__arrow {
  display: none !important;
}

button.el-button.moreBtn.el-button--text.el-button--small {
  color: #000;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-left: 20px !important;
  margin-top: 10px !important;
}

button.el-button.moreBtn.el-button--text.el-button--small.is-disabled {
  color: #C0C4CC;
}

button.el-button.searchIcon.el-button--default.el-button--medium {
  background: linear-gradient(135deg, #0561E3 0%, #0049AD 100%);
  color: #fff;
}

.aggregationPointManagement .el-tooltip {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.searchKeyClass .el-input--medium .el-input__inner {
  height: 28px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/aggregationPointManagement.vue